module.exports = __webpack_public_path__ + "img/Market Research 1.0c37384a.png";